import { config } from "@utils";
import { MenuName } from "../../../Navigation/components/Navbar/Navbar.types";
import { FooterLinks } from "./links.types";
import { StaticRoutes, ExternalRoutes, DynamicRoutes } from "@routes";

const jpFooterLinks: FooterLinks = [
  {
    title: MenuName.resourcesJP,
    id: "resources-footer-title",
    links: [
      {
        link: StaticRoutes.blog,
        text: "ブログ",
      },
      // commenting out as case studies and news & events will not be launching on JP site launch
      // {
      //   link: StaticRoutes.caseStudies,
      //   text: "他社成功事例",
      // },
      {
        link: StaticRoutes.newsAndEvents,
        text: "ニュース・イベント",
      },
    ],
  },
  {
    title: MenuName.featuresJP,
    id: "features-footer-title",
    links: [
      {
        link: StaticRoutes.featuresRewards,
        text: "リワード制度",
      },
      {
        link: StaticRoutes.featuresEmployeeApp,
        text: "YuLifeアプリ",
      },
    ],
  },
  {
    title: MenuName.aboutJP,
    id: "about-footer-title",
    links: [
      {
        link: StaticRoutes.aboutUs,
        text: "YuLifeについて",
      },
    ],
  },
  {
    title: MenuName.legalJP,
    id: "legal-footer-title",
    links: [
      {
        link: DynamicRoutes.privacyPolicy,
        text: "プライバシーポリシー",
      },
      {
        link: DynamicRoutes.cookiePolicy,
        text: "クッキーポリシー",
      },
      {
        link: DynamicRoutes.endUserLicenseAgreementPolicyUS,
        text: "エンドユーザー使用\\n許諾契約 (EULA)",
      },
    ],
  },
];

export default jpFooterLinks;
